export default __webpack_public_path__ + "static/media/desktopMockup3.43cbad54.jpg";